module.exports = __webpack_public_path__ + "static/media/vector-4964.4a9299a5.svg";